import moment from "moment-jalaali";
import fa from "moment/locale/fa";

moment.updateLocale("fa", fa);
moment.loadPersian([{ usePersianDigits: true }, { dialect: "persian-modern" }]);

export default {
  filters: {
    timeAgo(time) {
      return moment(time).fromNow();
    },
    dateFormat(time, format = "jD jMMMM jYYYY") {
      return moment(time).format(format);
    },
    dateDigitFormat(time, format = "jYYYY/jM/jD") {
      return moment(time).format(format);
    },
  },
};
